module.exports = __webpack_public_path__ + "img/logo_pc.8b1e9ce6.png";